import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";

import { Modal, Row, Table } from "react-bootstrap";
import { CancelButton } from "../../common/Button";
import { variant_type } from "../../../utils/common";
import ProductVariantModal from "./ProductVariantModal";
library.add(fas);

const ProductModal = (props) => {
  const data = props?.data;
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
    postData,
  } = useContext(Context);
  console.log(data, "datadata");

  const [showVariantModal, setShowVariantModal] = useState({
    show: false,
    data: [],
    product: "",
  });

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Product Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover responsive center>
            <thead>
              <tr className="">
                <th className="sr">Sr. No.</th>
                <th className="tax-name">Products </th>
                <th className="tax-name">Thumbnail</th>
                <th className="tax-name">Category </th>
                <th className="tax-name">Sub Category </th>
                <th className="tax-name">Quantity </th>
                <th className="tax-name">Single Quantity Price </th>
                <th className="tax-name">Multiple Quantity Price </th>
                <th className="tax-name">Discount</th>
                <th className="tax-name">Uploaded Images</th>
                <th className="tax-name">Variant Details</th>

                {/* <th className="tax-name">Sub Category </th>
                <th className="tax-name">Child category</th> */}
                {/* <th className="tax-name">Packing Charges </th> */}
                {/* <th className="tax-name">Delivery Charges </th> */}
                {/* <th className="tax-name">Refer Discount</th>
                <th className="tax-name">Offer Discount </th> */}
                {/* <th className="tax-name">Quantity </th>
                <th className="tax-name">Coupon Discount </th>
                <th className="tax-name">Total Tax </th>
                <th className="tax-name">Total Amount</th> */}
              </tr>
            </thead>
            <tbody>
              {data &&
                data?.length > 0 &&
                data?.map((item, index) => (
                  <tr className="" key={index}>
                    <td>{++index}</td>
                    <td>{item?.Product?.name}</td>
                    <td>
                      {item?.thumbnail ? (
                        <div className="d-flex flex-column align-items-center">
                          <img
                            src={IMG_URL + item?.thumbnail}
                            alt="thumbnail"
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "5px",
                              border: "1px solid #ddd",
                            }}
                          />

                          <button
                            type="button"
                            className="btn btn-sm btn-success mt-2"
                            onClick={async () => {
                              try {
                                const imageUrl = IMG_URL + item?.thumbnail;

                                const response = await fetch(imageUrl);

                                const blob = await response.blob();

                                const blobUrl =
                                  window.URL.createObjectURL(blob);

                                const link = document.createElement("a");

                                link.href = blobUrl;

                                link.download = `thumbnail-${index + 1}.webp`;

                                document.body.appendChild(link);

                                link.click();

                                link.remove();

                                window.URL.revokeObjectURL(blobUrl);
                              } catch (error) {
                                console.log("Thumbnail download failed", error);
                              }
                            }}
                          >
                            Download
                          </button>
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{item?.Product?.p_category?.name}</td>
                    <td>{item?.Product?.p_sub_category?.name}</td>
                    <td>{item?.quantity}</td>
                    <td>{item?.single_quantity_price}</td>
                    <td>{item?.multiple_quantity_price}</td>
                    <td>{item?.discount}</td>
                    <td>
                      {item?.Order_Upload_Images &&
                      item?.Order_Upload_Images?.filter(
                        (img) => img?.upload_image,
                      )?.length > 0 ? (
                        <div className="d-flex flex-column gap-3">
                          {item?.Order_Upload_Images?.filter(
                            (img) => img?.upload_image,
                          )?.map((img, i) => (
                            <div
                              key={i}
                              className="d-flex flex-column align-items-center"
                            >
                              <img
                                src={IMG_URL + img?.upload_image}
                                alt="uploaded"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  objectFit: "cover",
                                  borderRadius: "5px",
                                  border: "1px solid #ddd",
                                }}
                              />

                              <button
                                type="button"
                                className="btn btn-sm btn-primary mt-2"
                                onClick={async () => {
                                  try {
                                    const imageUrl =
                                      IMG_URL + img?.upload_image;

                                    const response = await fetch(imageUrl);

                                    const blob = await response.blob();

                                    const blobUrl =
                                      window.URL.createObjectURL(blob);

                                    const link = document.createElement("a");

                                    link.href = blobUrl;

                                    link.download = `image-${i + 1}.webp`;

                                    document.body.appendChild(link);

                                    link.click();

                                    link.remove();

                                    window.URL.revokeObjectURL(blobUrl);
                                  } catch (error) {
                                    console.log("Download failed", error);
                                  }
                                }}
                              >
                                Download
                              </button>
                            </div>
                          ))}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() =>
                          setShowVariantModal({
                            show: true,
                            data: item?.Product_Order_Variants,
                            product: item?.Product?.name,
                          })
                        }
                      >
                        Variant Details
                      </button>
                    </td>

                    {/* <td>
                      {item?.Product?.variant_type_id ===
                        variant_type.Single && (
                        <>
                          <strong>Metal:</strong>{" "}
                          {item?.Product_Variant?.Metal?.name}{" "}
                        </>
                      )}

                      {item?.Product?.variant_type_id ===
                        variant_type.Double && (
                        <>
                          <strong>Metal:</strong>{" "}
                          {item?.Double_Variant?.Product_Variant?.Metal?.name},{" "}
                          <strong>Size:</strong>{" "}
                          {item?.Double_Variant?.Size?.name}
                        </>
                      )}

                      {item?.Product?.variant_type_id ===
                        variant_type.Triple && (
                        <>
                          <strong>Metal:</strong>{" "}
                          {
                            item?.Triple_Variant?.Double_Variant
                              ?.Product_Variant?.Metal?.name
                          }
                          ,{"  "}
                          <strong>Size:</strong>{" "}
                          {item?.Triple_Variant?.Double_Variant?.Size?.name},{" "}
                          <strong>Diamond:</strong>{" "}
                          {item?.Triple_Variant?.Diamond?.name}
                        </>
                      )}
                    </td> */}

                    {/* <td>{item?.Product?.p_sub_category?.name}</td>
                    <td>{item?.Product?.p_child_category?.name}</td> */}

                    {/* <td>{item?.total_selling_price}</td> */}
                    {/* <td>{item?.packing_charges}</td> */}
                    {/* <td>{item?.delivery_charges}</td> */}
                    {/* <td>{item?.refer_discount}</td>
                     <td>{item?.offer_discount}</td> */}
                    {/* <td>{item?.quantity}</td>
                    <td>{item?.coupon_discount}</td>
                    <td>{item?.total_tax}</td>
                    <td>{item?.total_amount}</td> */}

                    {/* <td>
                      {item?.Order_Add_Ons &&
                        item?.Order_Add_Ons?.map((d, i) => (
                          <div key={i}>
                            {++i}. {d?.Food_Add_On?.name}
                          </div>
                        ))}
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </Table>
          <Row className="mt-5 pb-3">
            <div className="d-flex justify-content-center">
              <Link>
                <CancelButton name={"Close"} handleClose={props.handleClose} />
              </Link>
            </div>
          </Row>
        </Modal.Body>
      </Modal>
      <ProductVariantModal
        show={showVariantModal?.show}
        data={showVariantModal?.data}
        product={showVariantModal?.product}
        handleClose={() =>
          setShowVariantModal({
            show: false,
            data: [],
            product: "",
          })
        }
      />
    </>
  );
};

export default ProductModal;
